import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactStatus", "memo", "confirmedSchedule", "confirmedScheduleEnd", "testSchedule", "venueId", "meetingUrl", "meetingId", "meetingPasscode", "lockInfo"]
  static values = { candidateId: Number, projectId: Number, selectionListId: Number, interviewDurationMinutes: Number }

  connect() {
    this.draftTimer = null
  }

  disconnect() {
    if (this.draftTimer) clearTimeout(this.draftTimer)
    // NOTE: ロックはモーダル側（candidate-modal）が一括で取得・解放するため、
    // ここでは何もしない
  }

  // NOTE: モーダル側でロック管理するため、入力ごとの lock/unlock は no-op
  lockCandidate() {}
  unlockCandidate() {}

  saveDraft() {
    this.performSave()
  }

  debouncedSaveDraft() {
    if (this.draftTimer) clearTimeout(this.draftTimer)
    this.draftTimer = setTimeout(() => this.performSave(), 500)
  }

  async performSave() {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    const url = `/admin/projects/${this.projectIdValue}/selection_lists/${this.selectionListIdValue}/entries/save_draft`

    try {
      await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          candidate_id: this.candidateIdValue,
          contact_status: this.hasContactStatusTarget ? this.contactStatusTarget.value : "",
          memo: this.hasMemoTarget ? this.memoTarget.value : "",
          confirmed_schedule: this.hasConfirmedScheduleTarget ? this.confirmedScheduleTarget.value : "",
          confirmed_schedule_end: this.hasConfirmedScheduleEndTarget ? this.confirmedScheduleEndTarget.value : "",
          test_schedule: this.hasTestScheduleTarget ? this.testScheduleTarget.value : "",
          venue_id: this.hasVenueIdTarget ? this.venueIdTarget.value : "",
          meeting_url: this.hasMeetingUrlTarget ? this.meetingUrlTarget.value : "",
          meeting_id: this.hasMeetingIdTarget ? this.meetingIdTarget.value : "",
          meeting_passcode: this.hasMeetingPasscodeTarget ? this.meetingPasscodeTarget.value : ""
        })
      })
    } catch (error) {
      console.error("Failed to save preview form draft:", error)
    }
  }

  // 開始時間変更 → project.interview_duration_minutes が設定されていれば終了時刻を自動計算する。
  autoFillEndTime(event) {
    if (!this.hasConfirmedScheduleEndTarget) return
    const startValue = event.target.value
    if (!startValue || !this.interviewDurationMinutesValue) return

    const endValue = this.addMinutesToDatetimeLocal(startValue, this.interviewDurationMinutesValue)
    const endHidden = this.confirmedScheduleEndTarget
    const wrapper = endHidden.closest("[data-controller~='datetime-picker']")
    if (!wrapper) return
    const dpCtrl = this.application.getControllerForElementAndIdentifier(wrapper, "datetime-picker")
    if (dpCtrl && typeof dpCtrl.setValue === "function") dpCtrl.setValue(endValue)
  }

  addMinutesToDatetimeLocal(datetimeLocal, minutes) {
    const [datePart, timePart] = datetimeLocal.split("T")
    const [year, month, day] = datePart.split("-").map(Number)
    const [hour, minute] = timePart.split(":").map(Number)
    const d = new Date(year, month - 1, day, hour, minute + minutes)
    const pad = (n) => String(n).padStart(2, "0")
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
  }

  findChannelController() {
    const channelEl = this.element.closest("[data-controller~='workspace-channel']")
    if (!channelEl) return null
    return this.application.getControllerForElementAndIdentifier(channelEl, "workspace-channel")
  }
}
